module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagea"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/watch.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "frontmatter02"
    }
  }), _c('span', {
    staticClass: "boxnote3"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGEMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Many people helped me with "), _c('em', [_vm._v("Can I Have 5 Minutes of Your Time?")]), _vm._v(" One thing is for sure, I could never have done this project alone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("First off, my special thanks goes to Florence Mustric, whose genius and creativity enabled me to put my seminars in book form. She transformed words into mental pictures, and molded serious selling techniques with her wonderful sense of humor which made this book "), _c('em', [_vm._v("fun")]), _vm._v(" to read.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Also, to my first publisher, Roger Herman, for being the deal maker, and "), _c('em', [_vm._v("never")]), _vm._v(" going back on anything he said. He was truly a class act.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The staff at Mogan James, and their president David Hancock, made this revised edition a wonderful project. I was able to go back in time, to re-write this book and to truly see how little has changed in sales over the last two decades. They were the best publisher I have ever worked with due to their passion, sincerity, and above all, complete honesty and way of doing business.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Bob Shook provided his keen wisdom and book publishing expertise throughout the four years when we began this project. I am grateful for "), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _vm._v("his help, generosity of his time, and above all, his belief in me as a first-time author.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Lastly, all my close friends who are still in shock that I was able to even read a book, let alone write one, and to Jon Lief, whose creative warped mind came up with the title of this book in 27 seconds.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cf76d4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter02.vue
// module id = 75
// module chunks = 0